// extracted by mini-css-extract-plugin
module.exports = {"order_panel":"Order_order_panel__gvnhl","order_items":"Order_order_items__26YS-","total":"Order_total__HEoLp"};